import { translateBackend } from '@assets/i18n/config';
import { Box, Typography } from 'hephaestus/web';
import type { Ref } from 'react';
import { useTranslation } from 'react-i18next';
import type { CalculatorState } from '../useCalculator';
import { CalculatorInputPanel } from './calculatorInputPanel';
import { CalculatorResultsPanel } from './calculatorResultsPanel';

export const CalculatorPdfCaptureClone = ({
  calculator,
  inputRef,
  options,
  resultsRef,
}: {
  calculator: CalculatorState;
  inputRef: Ref<HTMLDivElement>;
  options: Record<string, unknown>;
  resultsRef: Ref<HTMLDivElement>;
}) => {
  const { t } = useTranslation('workflowCompletions');

  return (
    <div
      aria-hidden='true'
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '1060px',
        zIndex: -9999,
        pointerEvents: 'none',
      }}
    >
      <div ref={inputRef}>
        <Box
          data-pdf-section
          sx={{ display: 'flex', flexDirection: 'column', pb: 1 }}
        >
          <Typography variant='headingMedium' sx={{ fontWeight: 500 }}>
            {translateBackend(options.title) || t('calculator.title')}
          </Typography>
        </Box>
        <CalculatorInputPanel
          calculator={calculator}
          forPrint
          options={options}
        />
      </div>
      <div ref={resultsRef}>
        <CalculatorResultsPanel
          calculator={calculator}
          forceAllExpanded
          options={options}
        />
      </div>
    </div>
  );
};
